<template>
    <div>
        <v-radio-group
                column
                @change="setStore"
                label="Evalanche Store"
                :rules="storeRules"
                :value="store"
                :loading="loading"
                :disabled="loading">
            <v-radio
                    v-for="s in stores"
                    :key="s.value"
                    :color="s.color"
                    :value="s.value"
                    :label="s.label"></v-radio>
        </v-radio-group>
    </div>
</template>
<script>

export default {
    name: 'EvalancheStoreSelect',
    props: ['store', 'loading'],
    data() {
        return {
            stores: [{
                color: 'success',
                label: 'A. Beig Verlag',
                value: 458751,
            }, {
                color: 'success',
                value: 458748,
                label: 'medienhaus:nord',
            }, {
                color: 'success',
                value: 458750,
                label: 'NNN',
            }, {
                color: 'success',
                value: 458752,
                label: 'NOZ',
            }, {
                color: 'success',
                value: 458749,
                label: 'sh:z',
            }],
            storeRules: [
                v => (!!v) || 'Es muss ein Evalanche Store ausgewählt werden',
            ],
        };
    },
    methods: {
        setStore(payload) {
            this.$emit('change', payload);
        },
    },
};

</script>
<style scoped lang="scss">
    .v-input--radio-group__input > label.v-label {
        font-weight: bold;
    }
</style>
